import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "as-scrolling as-scrolling__have-tab as-scrolling__result-popup" }

import { ref, computed } from "vue";
import type { ILineups, IMatch, IPlayer } from "~src/interfaces";
import Squad from '~src/components/lineups/Squad.vue';
import SquadEmpty from '~src/components/lineups/SquadEmpty.vue';
import Players from '~src/components/lineups/Players.vue';
import InjuriesSuspensions from '~src/components/lineups/InjuriesSuspensions.vue';
import TabsBtn from "~src/components/TabsBtn.vue";
import { usecommonStore } from "~src/stores/CommonStore";

const __default__ = {};

interface IProps {
  lineups: ILineups;
  match: IMatch;
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'Lineups',
  props: {
    lineups: {},
    match: {}
  },
  setup(__props: any) {

const commonStore = usecommonStore();

const props = __props;
const siteName = computed(() => commonStore.getSiteName);
const activeTab = ref("squad");

const tabs = [
  {
    title: "Sơ đồ",
    key: "squad",
  },
  {
    title: "Ra sân",
    key: "players",
  },
  {
    title: "Chấn thương & treo giò",
    key: "injuries_suspensions",
  },
];

const changeTab = (val: string) => {
  activeTab.value = val;
};

const startingPlayers = computed(() => {
  let result = [
    {
      type: "Starting Lineups",
      data: { home: <Array<IPlayer>>[], away: <Array<IPlayer>>[] },
    },
    { type: "Substitutes", data: { home: [], away: [] } },
    { type: "Injured or suspended", data: { home: [], away: [] } },
  ];
  try {
    let flag = false;
    try {
      const lineupSideHome = props.lineups?.lineup?.home || null;
      if (lineupSideHome) {
        for (const player of lineupSideHome) {
          if (player.first === 1) {
            result[0].data.home.push(player);
            flag = true;
          } else if ([-1, 2, 3].indexOf(player.first) === -1) {
            result[1].data.home.push(player);
            flag = true;
          }
        }
      }
      const lineupSideAway = props.lineups?.lineup?.away || null;
      if (lineupSideAway) {
        for (const player of lineupSideAway) {
          if (player.first === 1) {
            result[0].data.away.push(player);
            flag = true;
          } else if ([-1, 2, 3].indexOf(player.first) === -1) {
            result[1].data.away.push(player);
            flag = true;
          }
        }
      }

      if (props.lineups && props.lineups.injury.home) {
        result[2].data.home = props.lineups.injury.home;
        flag = true;
      }
      if (props.lineups && props.lineups.injury.away) {
        result[2].data.away = props.lineups.injury.away;
        flag = true;
      }
    } catch (e) {
      console.error(e);
    }
  } catch (error) {
    console.log(error);
  }

  return result;
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`as-parent-lineups as-parent-lineups-${siteName.value}`)
  }, [
    _createVNode(TabsBtn, {
      tabs: tabs,
      activeTab: activeTab.value,
      onChange: changeTab,
      isShowBorder: true
    }, null, 8, ["activeTab"]),
    _createElementVNode("div", _hoisted_1, [
      (_ctx.lineups)
        ? _withDirectives((_openBlock(), _createBlock(Squad, {
            key: 0,
            match: _ctx.match,
            lineups: _ctx.lineups,
            startingPlayers: startingPlayers.value[1].data
          }, null, 8, ["match", "lineups", "startingPlayers"])), [
            [_vShow, activeTab.value === 'squad']
          ])
        : (activeTab.value === 'squad')
          ? (_openBlock(), _createBlock(SquadEmpty, { key: 1 }))
          : _createCommentVNode("", true),
      _withDirectives(_createVNode(Players, {
        match: _ctx.match,
        lineups: _ctx.lineups,
        startingPlayers: startingPlayers.value[0].data
      }, null, 8, ["match", "lineups", "startingPlayers"]), [
        [_vShow, activeTab.value === 'players']
      ]),
      _withDirectives(_createVNode(InjuriesSuspensions, {
        match: _ctx.match,
        lineups: _ctx.lineups,
        startingPlayers: startingPlayers.value[2].data
      }, null, 8, ["match", "lineups", "startingPlayers"]), [
        [_vShow, activeTab.value === 'injuries_suspensions']
      ])
    ])
  ], 2))
}
}

})